module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/IPCカメラ.5ccb4b59.png";